import React from 'react';
import ConfigHeader from '@/component/helper/ConfigHeader';
import { usePageHeight } from '../../../util/hook/usePageHeight';
import { S } from './style';
import Loading from '../../atom/Loading';
export default function RWDPageLayout({ children, isLoading }) {
    const { pageHeight } = usePageHeight();
    return (<S.Layout>
      <S.PageContent height={pageHeight}>
        {isLoading ? <Loading /> : null}
        <ConfigHeader />
        {children}
      </S.PageContent>
    </S.Layout>);
}
